// extracted by mini-css-extract-plugin
export default {"inputOrderWrapper":"styles_inputOrderWrapper__1hhkN","sortButton":"styles_sortButton__E7pBw"};